import React, { useEffect, useState } from "react";

import { AccordionProps } from "./Accordion.model";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";

import "@companion-core/web/src/Assets/Styles/scss/accordion.scss";
import { sanitizeHtml } from "@companion-core/shared/app/Utils/htmlSanitizer";

export const Accordion = ({
  title,
  description,
  className,
  expanded = false,
  onClick,
  testID,
}: AccordionProps) => {
  const [isExpanded, setIsExpanded] = useState(expanded);

  useEffect(() => {
    setIsExpanded(expanded);
  }, [expanded]);

  return (
    <div data-testid={`accordion-${testID}`} className={`accordion ${className ?? ""}`}>
      <div
        data-testid={`accordion__title-${testID}`}
        className="accordion__title"
        onClick={() => {
          setIsExpanded(!isExpanded);
          onClick && onClick(!isExpanded);
        }}>
        <span className="body-text-6 accordion__title-text">{title}</span>
        <FontIcon name={isExpanded ? "JP-Minus" : "JP-Plus"} size={24} />
      </div>
      <div
        data-testid={`accordion__description-${testID}`}
        className={`body-text-6 accordion__description${
          isExpanded ? " accordion__description--expanded" : ""
        }`}
        // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(description ?? "") }}
      />
    </div>
  );
};
